import * as React from "react";
import Chart from "./Chart/Chart";
import MetricsAnalysis from "./MetricsAnalysis/MetricsAnalysis";
import Statistics from "./Statistics/Statistics";
import Eventlog from "./Eventlog/Eventlog";

const MainContent = ({ workspaceData }) => {
  return (
    <>
      <div className={'row'}>
        <Chart data={workspaceData?.dashboard_data?.bar_char_data} dataPoolName={workspaceData?.data_pool_name} />
        <MetricsAnalysis
          metricsAnalysis={workspaceData?.dashboard_data?.metrics_analysis_table}
          analyses={workspaceData?.analysis_count}
          variants={workspaceData?.dashboard_data?.variant_count}
          totalCases={workspaceData?.dashboard_data?.total_cases}
          activities={workspaceData?.dashboard_data?.unique_activity}
        />
      </div>
      <div className={'row mt-3'}>
        <Statistics data={workspaceData?.dashboard_data?.statistics_table} />
        <Eventlog data={workspaceData?.dashboard_data?.eventlog_table} />
      </div>
    </>
  )
}

export default MainContent